export default __webpack_public_path__ + "static/media/sort-numeric-up.06250fb3.svg";